import axios from "axios";
import { handleApiError } from "./utils/handleApiError";
import { env } from "util/env";
const ZOHO = window.ZOHO;

export const getConfigFromDB = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  settingApiName = "",
  settingId,
  settingType = "",
}) => {
  const setting_url = `${env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings`;

  let params = {};

  if (settingApiName !== "") {
    params["moduleApiName"] = settingApiName;
  }

  if (settingType !== "") {
    params["settingType"] = settingType;
  }

  let settingApiUrl = settingId
    ? `${setting_url}/${settingId}`
    : `${setting_url}`;

  try {
    let reqOptions = {
      url: settingApiUrl,
      method: "GET",
      headers: {
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: env.REACT_APP_EXTENSION_IDENTIFIER,
      },
      params,
    };
    const settingResp = await axios(reqOptions);
    return { data: settingResp?.data?.data, error: null };
  } catch (saveConfigToDBError) {
    return {
      data: null,
      error: "Something went wrong",
    };
  }
};

export const upsertConfigToDB = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  settingApiName,
  settingId,
  settingSchema,
  settingType,
}) => {
  try {
    let reqOptions = {
      url: `${env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings`,
      method: "POST",
      data: {
        settingType,
        moduleApiName: settingApiName,
        settingId,
        settingSchema,
      },
      headers: {
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: env.REACT_APP_EXTENSION_IDENTIFIER,
      },
    };
    const folderResp = await axios(reqOptions);

    return { data: folderResp?.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: handleApiError("upsertConfigToDB", error),
    };
  }
};

export const saveConfigToZoho = async ({
  orgId,
  dataCenterUrl,
  settingType,
  moduleApiName,
  settingId,
}) => {
  try {
    const data = {
      connname: env.REACT_APP_EXTENSION_IDENTIFIER,
      orgid: orgId,
      datacenterurl: dataCenterUrl,
      settingType,
      moduleApiName,
      settingId,
    };
    const resp = await ZOHO.CRM.ACTION.setConfig(data);

    return {
      data: resp,
      error: null,
    };
  } catch (error) {
    return {
      data: null,
      error: handleApiError("saveConfigToZoho", error),
    };
  }
};

export const deleteConfigFromDB = async ({
  orgId,
  apiKey,
  dataCenterUrl,
  settingId,
}) => {
  try {
    let reqOptions = {
      url: `${env.REACT_APP_ADMIN_SERVER_URL}/db/planetscale/clients/settings/${settingId}`,
      method: "DELETE",
      headers: {
        orgid: orgId,
        apikey: apiKey,
        datacenterurl: dataCenterUrl,
        connname: env.REACT_APP_EXTENSION_IDENTIFIER,
      },
    };
    const folderResp = await axios(reqOptions);

    return { data: folderResp?.data, error: null };
  } catch (error) {
    return {
      data: null,
      error: handleApiError("saveConfigToZoho", error),
    };
  }
};

export const config = {
  getConfigFromDB,
  saveConfigToZoho,
  upsertConfigToDB,
  deleteConfigFromDB,
};
